module.exports = __webpack_public_path__ + "img/Feature.837ed3fa.png";